export default __webpack_public_path__ + "static/media/InnerRectangle.6b6f5352.svg";